import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  clearAll,
  onUserLogin,
  setErrorMessage,
  setLoading,
} from "../../../config/redux/slice/authSlice";
import { postRequest } from "../../../helpers/request";
import { appApi } from "../../../utils/endpoints/appApi";
import { appUrls } from "../../../utils/urls/appUrls";
import { AuthAlert, Spinner } from "../../components";
import AuthFormWrapper from "../../layout/AuthFormWrapper";

export default function EmailVerificationLinkSentScreen() {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onTouched" });

  const [successMessage, setSuccessMessage] = useState(false);

  const {
    loading,
    errorMsg,
    userTemporaryDetails: { email },
  } = useSelector((state) => state.authData);

  useEffect(() => {
    dispatch(clearAll({}));
  }, []);

  const resendEmail = async (e) => {
    e.preventDefault();
    dispatch(clearAll({}));
    setSuccessMessage(false);
    const res = await postRequest(
      "",
      `${appApi.resend_verification_link}`,
      { email },
      dispatch,
      setLoading,
      "",
      setErrorMessage,
    );
    if (res !== undefined && res.status < 400) {
      setSuccessMessage(true);
    }
  };

  const closeErrorAlert = () => {
    dispatch(setErrorMessage({ message: null }));
  };

  const closeSuccessAlert = () => {
    setSuccessMessage(false);
  };

  return (
    <AuthFormWrapper sub_text="We Have Sent You An Email" icon="mdi mdi-email">
      {successMessage && (
        <AuthAlert
          onClick={closeSuccessAlert}
          alertStyles={{ width: "95%", margin: "0 auto" }}
          status="success"
        >
          Email Verification Link Sent
        </AuthAlert>
      )}
      {errorMsg && (
        <AuthAlert
          onClick={closeErrorAlert}
          alertStyles={{ width: "95%", margin: "0 auto" }}
          status="error"
        >
          {errorMsg}
        </AuthAlert>
      )}
      <div className="text-center mb-5" style={{ color: "#31343D" }}>
        <p style={{ lineHeight: "1.8rem" }}>
          Click on the email verification link sent to you on <b>{email}</b> to
          verify your email
        </p>
      </div>
      <div className="col-md-12">
        <button type="button" className="btn btn-outline-primary mb-4">
          <i className=" mdi mdi-arrow-left-thick mr-1"></i>
          <a className="text-hover-white" href="https://techreg.notap.gov.ng/">
            Visit Site
          </a>
        </button>
        {/* <Spinner/> */}

        <div style={{ columnGap: "0.4rem" }} className="d-flex">
          <p>Didn't receive the email yet?</p>
          <a
            onClick={(e) => {
              resendEmail(e);
            }}
            className="text-blue"
            role="button"
          >
            Send Again
          </a>
        </div>
      </div>
    </AuthFormWrapper>
  );
}
